import { ErrorPage } from 'views/pages/error/ErrorPage';

const NextError = ({ statusCode }: { statusCode?: number }) => {
  return <ErrorPage statusCode={statusCode} />;
};

NextError.getInitialProps = async ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : null;

  // This will contain the status code of the response
  return { statusCode };
};

export default NextError;
